import { Action } from '@/components/sections/Card';
import SiEdit from '@/icons/SiEdit';
import { productExplorerStrings } from '@/pages/product/strings';
import { Product } from '@/services/api/contracts/catalog/types';
import { RoleType } from '@/services/authentication/hooks/user';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import ToggleProductToOrderAction from '../ToggleProductToOrderAction';
import ToggleSelectedProductAction from '../ToggleSelectedProductAction';

interface Props {
  product: Product;
  openDetailsModal: () => void;
  openMarginModal: () => void;
  openUnselectProductErrorModal: () => void;
}

export const ProductCardOptions: FC<Props> = ({
  product,
  openDetailsModal,
  openMarginModal,
  openUnselectProductErrorModal
}) => {
  const [configuration, inPurchaseOrder] = useCatalogueService(state => [state.configuration, state.inPurchaseOrder]);
  const navigate = useNavigate();

  const showProductMargin =
    configuration.for === RoleType.Company &&
    (configuration.as === RoleType.Admin || configuration.as === RoleType.Partner);

  return (
    <>
      {configuration.for === RoleType.Admin && (
        <Action
          onClick={() => navigate(`/configuratorCatalogue/product/${product.id}`)}
          className="flex w-full items-center justify-center gap-1 p-2 text-sm"
        >
          <SiEdit className="text-2xl" />
          <span className="font-medium">{productExplorerStrings.editProductInfo}</span>
        </Action>
      )}
      {!inPurchaseOrder && (
        <Action onClick={openDetailsModal} className="flex w-full items-center justify-center gap-1 p-2 text-sm">
          <span className="font-medium">{productExplorerStrings.seeProductInfo}</span>
        </Action>
      )}
      {showProductMargin && !inPurchaseOrder && (
        <Action onClick={openMarginModal} className="flex w-full items-center justify-center gap-1 p-2 text-sm">
          <span className="font-medium">{productExplorerStrings.setProductMargin}</span>
        </Action>
      )}
      {configuration.for === RoleType.Company && !inPurchaseOrder && (
        <ToggleSelectedProductAction product={product} openUnselectProductErrorModal={openUnselectProductErrorModal} />
      )}
      {configuration.for === RoleType.Company && inPurchaseOrder && <ToggleProductToOrderAction product={product} />}
    </>
  );
};
